import { FC } from 'react'
import { FormControlLabel, FormLabel, Radio, RadioGroup as RadioGroupMUI } from '@mui/material'
import { RenderIf } from 'shared/helpers/renderIf'
import { RadioContainer } from './styled'
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace'

export const RadioGroup: FC<IRadioGroup> = ({
  options,
  value,
  defaultValue,
  handleChange,
  title,
  isRow = false,
  sx = {}
}) => {
  return (
    <RadioContainer>
      <RenderIf condition={Boolean(title)}>
        <FormLabel id='radio-group-label'>{title}</FormLabel>
      </RenderIf>
      <RadioGroupMUI
        row={isRow}
        name='use-radio-group'
        aria-labelledby='radio-group-label'
        value={value}
        onChange={e => handleChange(e.target.value)}
        defaultValue={defaultValue}
        sx={sx}
      >
        {options?.map(option => (
          <FormControlLabel
            key={`radio_option_${option.value}`}
            value={option.value}
            label={option.label}
            control={<Radio />}
          />
        ))}
      </RadioGroupMUI>
    </RadioContainer>
  )
}

interface IRadionOption {
  label: string | ReactJSXElement
  value: number | string
}

interface IRadioGroup {
  defaultValue?: number | string
  value?: number | string
  handleChange: (e: string) => void
  options: IRadionOption[]
  isRow?: boolean
  title?: string
  sx?: Object
}
